import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { HomeProject } from '@models/swagger';
import { GetProjectByIdParams } from './service';

export enum GetProjectByIdActions {
  Failure = '[Project GetProjectById] Failure',
  Request = '[Project GetProjectById] Request',
  Success = '[Project GetProjectById] Success',
  Reset = '[Project GetProjectById] Reset',
}

export const GetProjectByIdFailure = createAction(GetProjectByIdActions.Failure, props<{ error: HttpErrorResponse }>());

export const GetProjectByIdRequest = createAction(
  GetProjectByIdActions.Request,
  props<{ parameters: GetProjectByIdParams }>()
);

export const GetProjectByIdSuccess = createAction(GetProjectByIdActions.Success, props<{ data: HomeProject }>());

export const GetProjectByIdReset = createAction(GetProjectByIdActions.Reset);
